import { motion } from "framer-motion";
import { STATS } from "../lib/data";

export default function Stats() {
  return (
    <section
      data-testid="stats-section"
      className="relative bg-[#0A0B0E] border-y border-white/5 py-20 lg:py-28"
    >
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
        <div className="flex items-center gap-4 mb-12">
          <span className="w-8 h-px bg-[#D4AF37]" />
          <span className="text-[#D4AF37] text-xs uppercase tracking-[0.3em]">
            Resultados medibles
          </span>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-16">
          {STATS.map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              data-testid={`stat-${i}`}
              className="relative"
            >
              <div className="font-display text-7xl lg:text-8xl font-light text-white leading-none tracking-tighter">
                {s.value}
                <span className="text-[#D4AF37] font-display italic">{s.suffix}</span>
              </div>
              <div className="mt-4 text-sm lg:text-base text-white/55 font-light max-w-[200px]">
                {s.label}
              </div>
            </motion.div>
          ))}
        </div>

        {/* Brand marquee */}
        <div className="mt-20 pt-12 border-t border-white/5 overflow-hidden">
          <div className="text-xs uppercase tracking-[0.3em] text-white/40 mb-6">
            Marcas certificadas con las que trabajamos
          </div>
          <div className="flex items-center gap-16 text-3xl lg:text-4xl font-display italic text-white/30">
            <span>3M</span>
            <span className="w-1.5 h-1.5 rounded-full bg-[#D4AF37]" />
            <span>Solex</span>
            <span className="w-1.5 h-1.5 rounded-full bg-[#D4AF37]" />
            <span>Llumar</span>
            <span className="w-1.5 h-1.5 rounded-full bg-[#D4AF37]" />
            <span>Protección Civil</span>
          </div>
        </div>
      </div>
    </section>
  );
}
